import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-book-selection__options" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]

import { computed, onMounted, ref, watch } from 'vue'

import { getQuestionnaireBooks, QuestionnaireView } from '@/models/onboarding'
import type {
  GenreSelectionChoice,
  BookSelectionPage,
  QuestionnaireBook,
} from '@/models/onboarding.types'
import { cacheBust } from '@/models/doc'

import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookSelection',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as BookSelectionPage
})

const selectedOptions = ref<QuestionnaireBook[]>([])

watch(selectedOptions, (newValue) => {
  // Sync the component state with the view,
  // but only send the properties we need.
  props.view.setCurrentChoice(
    newValue.map((option) => ({
      id: option.id,
      title: option.title,
      cover: option.cover,
    })),
  )

  // Only show the continue button once the user
  // has selected at least 3 options.
  if (newValue.length >= 3) {
    props.view.showContinueButton()
  } else {
    props.view.hideContinueButton()
  }
})

function toggleOption(option: QuestionnaireBook): void {
  const alreadySelected = selectedOptions.value.some(
    (oldValue) => oldValue.id === option.id,
  )

  const newValue = alreadySelected
    ? selectedOptions.value.filter((oldValue) => oldValue.id !== option.id)
    : [...selectedOptions.value, option]

  selectedOptions.value = newValue
}

function isSelected(optionID: string): boolean {
  return selectedOptions.value.some((option) => option.id === optionID)
}

const options = computed(() => {
  const selectedGenres =
    props.view.getUserChoice<GenreSelectionChoice>('genre-selection')

  return getQuestionnaireBooks(selectedGenres)
})

const subtitle = computed(() => {
  const booksSelectedNumber = selectedOptions.value.length

  if (booksSelectedNumber === 0) {
    return 'Select at least 3 books'
  }

  return `${booksSelectedNumber} books selected`
})

onMounted(() => {
  // The default value of `view.currentChoice` is `undefined`.
  // The value of the choices for this page is an array, so
  // we set the initial value of `view.currentChoice` to an
  // empty array so that we can spread the current value
  // without having to check if it's an array first.
  props.view.setCurrentChoice([])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-book-selection",
    title: page.value.title,
    subtitle: subtitle.value,
    scrollDefaultSlot: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            key: option.id,
            class: _normalizeClass(["onboarding-book-selection__option", {
          'onboarding-book-selection__option--selected': isSelected(option.id),
        }]),
            onClick: ($event: any) => (toggleOption(option))
          }, [
            _createElementVNode("img", {
              src: _unref(cacheBust)(option.cover),
              width: "100",
              height: "133",
              alt: "",
              class: "onboarding-book-selection__cover"
            }, null, 8, _hoisted_3),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "onboarding-book-selection__check" }, [
              _createElementVNode("span", { class: "iconfont icheck-bold" })
            ], -1))
          ], 10, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title", "subtitle"]))
}
}

})